import Navigation from "../app/components/NavigationSPA";

interface VideoCard {
  title: string;
  description: string;
  youtubeId: string;
}

const VIDEOS: VideoCard[] = [
  {
    title: "SmartProbe Set Up Tutorial",
    description: "Learn how to set up your SmartProbe device",
    youtubeId: "WFRFPraDB3I",
  },
  {
    title: "SmartProbe Mobile App Walkthrough",
    description: "Navigate the SmartProbe mobile application",
    youtubeId: "Ic7bxvvWn4w",
  },
  {
    title: "SmartProbe Website Walkthrough",
    description: "Explore the SmartProbe website application",
    youtubeId: "U0ulR-WTnwk",
  },
];

export default function TutorialVideosPage() {
  return (
    <div className="min-h-screen bg-gray-100">
      <Navigation />

      <main className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="px-4 py-6 sm:px-0">
          {/* Page header */}
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900">Tutorial Videos</h1>
            <p className="text-gray-500 mt-1">
              Learn how to use SmartProbe with our comprehensive video tutorials
            </p>
          </div>

          {/* Video grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {VIDEOS.map((video) => (
              <div
                key={video.youtubeId}
                className="bg-white rounded-lg shadow overflow-hidden flex flex-col"
              >
                {/* YouTube embed */}
                <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
                  <iframe
                    className="absolute inset-0 w-full h-full"
                    src={`https://www.youtube.com/embed/${video.youtubeId}`}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                </div>

                {/* Card info */}
                <div className="p-4 flex flex-col flex-1">
                  <h2 className="text-base font-bold text-gray-900">{video.title}</h2>
                  <p className="text-sm text-gray-500 mt-1">{video.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
